import Heading from 'LuxKit/Typography/Heading'
import type { PropsWithChildren } from 'react'

interface Props extends PropsWithChildren {
  lineClamp?: number
}

function SearchTileRowTitle({ children, lineClamp = 3 }: Props) {
  return <Heading variant="heading5" lineClamp={lineClamp}>
    {children}
  </Heading>
}

export default SearchTileRowTitle
